import React from 'react';
import { Grid, Box } from '@mui/material';
import { AddPlayerDomain } from './addPlayer.domain';
import { di } from '../../state/inversify.config';
import { PlayerListTable } from './playerListTable/playerTable';
import { ConneqtOnAddPlayerDomain } from './addConneqtModal/conneqtOnAddPlayer.domain';
import { AccountTypes } from '../../components/changeUser/accountTypes.enum';
import { PlayerListByCard } from './playerListTable/playerListByCard';

export function PlayerList() {
  const conneqtOnAddPlayerDomain = di.get<ConneqtOnAddPlayerDomain>(
    ConneqtOnAddPlayerDomain,
  );

  const addPlayerDomain = di.get<AddPlayerDomain>(AddPlayerDomain);
  const accountType = addPlayerDomain.useAccountTypeSelector();

  return (
    <>
      {accountType && accountType !== AccountTypes.Guardian && (
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Box sx={{ minWidth: '100%' }}>
            <PlayerListTable
              playerDomain={addPlayerDomain}
              conneqtOnAddPlayerDomain={conneqtOnAddPlayerDomain}
            />
          </Box>
        </Grid>
      )}
      {accountType && accountType === AccountTypes.Guardian && (
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <PlayerListByCard
            conneqtOnAddPlayerDomain={conneqtOnAddPlayerDomain}
            playerDomain={addPlayerDomain}
          />
        </Grid>
      )}
    </>
  );
}
